import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d9fca29"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ActivityButton__border"
}
const _hoisted_2 = {
  key: 1,
  class: "ActivityButton__btn ActivityButton__btn--ani",
  id: "deeplink"
}
const _hoisted_3 = {
  key: 0,
  class: "ActivityButton__tag"
}
const _hoisted_4 = { class: "ActivityButton__tip" }

import { computed, onMounted } from 'vue';

import { useStore } from '@/store';
import { useBtn } from '@/hooks/useBtn';

import getDeepLink from '@kk/deeplink';
import { useGlobalData } from '@/hooks/useGlobalData';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { btnMode, buttonText, clickBtn } = useBtn();

const store = useStore();

const inviteNewUserCanObtain = computed(
  () => store.state.rule.inviteNewUserCanObtain
);

const inviteOldUserCanObtain = computed(
  () => store.state.rule.inviteOldUserCanObtain
);

const fixedBtn = computed(() => store.getters.fixedBtn);

const global = useGlobalData();

onMounted(() => {
  if (!global.isKuaikan) {
    getDeepLink({
      el: '#deeplink',
      mode:
        process.env.VUE_APP_HOST_ENV === 'production' ||
        process.env.VUE_APP_HOST_ENV === 'preview'
          ? 'live'
          : 'test',
      isAdsShow: 0,
      params: {
        action: {
          target_id: 1,
          target_title: '组队赚KK币',
          target_web_url: `${process.env.VUE_APP_DEEPLINK}${location.search}&conf2scrollwhitearea=1&conf2fullscreen=1&statusbar=0`,
          action_type: 18,
        },
        //新版埋点，必填，否则无法生成短链，具体埋点字段详细信息，可参考底部链接-埋点文档
        trackingList: [
          {
            //打开deeplink埋点，默认上报
            PropertyEvent: 'OpenAppByDeepLink', //埋点事件名
            ServiceType: 1, //default，0:其他；1：share; 2：M站；3:渠道投放；4：短信召回， 备注：当值为1时，需上报share埋点
            ServiceName: '组队赚KK币', //default，业务参数，产品用于区分各种目标页
          },
          {
            //share埋点，只有上面ServiceType为1时，才上报该埋点，否则不用
            PropertyEvent: 'ShareOpenAPPDetailPage', //埋点事件名
            ShareContentType: 2, //default  内容类型
            SubType: -1, //default  子类型
            SubjectID: '组队赚KK币', //default
            ShareWay: 1, //默认，取地址参数 => h5:1，图片：3
          },
        ],
      },
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_unref(btnMode))
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["ActivityButton", { 'ActivityButton--fixed': _unref(fixedBtn) }])
      }, [
        (_unref(fixedBtn))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1))
          : _createCommentVNode("", true),
        (_unref(btnMode) === 'deeplink')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(buttonText)), 1))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass(["ActivityButton__btn", {
        'ActivityButton__btn--disabled': _unref(btnMode) === 'full',
        'ActivityButton__btn--ani': _unref(btnMode) !== 'full',
      }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(clickBtn)()))
            }, [
              _createTextVNode(_toDisplayString(_unref(buttonText)) + " ", 1),
              (_unref(btnMode) === 'share' || _unref(btnMode) === 'start')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 最高KK币+" + _toDisplayString(_unref(inviteNewUserCanObtain)), 1))
                : _createCommentVNode("", true)
            ], 2)),
        _createElementVNode("div", _hoisted_4, " 邀新用户+" + _toDisplayString(_unref(inviteNewUserCanObtain)) + "KK币，邀原快看用户+" + _toDisplayString(_unref(inviteOldUserCanObtain)) + "KK币 ", 1)
      ], 2))
    : _createCommentVNode("", true)
}
}

})